var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#40C4FF;}\n\t.st1{fill:#263238;}\n\t.st2{fill:#FFD740;}\n\t.st3{fill:#FF5252;}\n\t.st4{fill:#4DB6AC;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#4FC3F7;}\n\t.st7{fill:#37474F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11.5,
    className: "st2",
    width: 32,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42,28H10c-0.276,0-0.5-0.224-0.5-0.5v-16c0-0.276,0.224-0.5,0.5-0.5h32c0.276,0,0.5,0.224,0.5,0.5v16 C42.5,27.776,42.276,28,42,28z M10.5,27h31V12h-31V27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44,59H8c-1.654,0-3-1.346-3-3V9c0-1.654,1.346-3,3-3h36c1.654,0,3,1.346,3,3v47C47,57.654,45.654,59,44,59z  M8,7C6.897,7,6,7.897,6,9v47c0,1.103,0.897,2,2,2h36c1.103,0,2-0.897,2-2V9c0-1.103-0.897-2-2-2H8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,64H12c-1.654,0-3-1.346-3-3v-0.5C9,60.224,9.224,60,9.5,60s0.5,0.224,0.5,0.5V61c0,1.103,0.897,2,2,2h37 c1.103,0,2-0.897,2-2V14c0-1.103-0.897-2-2-2h-0.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H49c1.654,0,3,1.346,3,3v47 C52,62.654,50.654,64,49,64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53,3h-4c-0.276,0-0.5-0.224-0.5-0.5S48.724,2,49,2h4c0.276,0,0.5,0.224,0.5,0.5S53.276,3,53,3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51,5c-0.276,0-0.5-0.224-0.5-0.5v-4C50.5,0.224,50.724,0,51,0s0.5,0.224,0.5,0.5v4C51.5,4.776,51.276,5,51,5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,8.5h-4C54.224,8.5,54,8.276,54,8s0.224-0.5,0.5-0.5h4C58.776,7.5,59,7.724,59,8S58.776,8.5,58.5,8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,10.5c-0.276,0-0.5-0.224-0.5-0.5V6c0-0.276,0.224-0.5,0.5-0.5S57,5.724,57,6v4 C57,10.276,56.776,10.5,56.5,10.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,24.5c-0.107,0-0.215-0.034-0.307-0.105c-0.218-0.169-0.257-0.483-0.087-0.701l7-9 c0.091-0.117,0.229-0.188,0.378-0.193c0.161-0.01,0.292,0.057,0.39,0.168l7.601,8.551l6.631-8.525 c0.17-0.218,0.483-0.258,0.702-0.088c0.218,0.169,0.257,0.483,0.087,0.701l-7,9c-0.091,0.117-0.229,0.188-0.378,0.193 c-0.166-0.003-0.292-0.057-0.39-0.168l-7.601-8.551l-6.631,8.525C15.296,24.434,15.148,24.5,15,24.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 15,
    cy: 24,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,26c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S16.103,26,15,26z M15,23c-0.551,0-1,0.448-1,1 s0.449,1,1,1s1-0.448,1-1S15.551,23,15,23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 30,
    cy: 24,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,26c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S31.103,26,30,26z M30,23c-0.551,0-1,0.448-1,1 s0.449,1,1,1s1-0.448,1-1S30.551,23,30,23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 22,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,17c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S23.103,17,22,17z M22,14c-0.551,0-1,0.448-1,1 s0.449,1,1,1s1-0.448,1-1S22.551,14,22,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 37,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,17c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S38.103,17,37,17z M37,14c-0.551,0-1,0.448-1,1 s0.449,1,1,1s1-0.448,1-1S37.551,14,37,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,54c-3.584,0-6.5-2.916-6.5-6.5S32.416,41,36,41s6.5,2.916,6.5,6.5S39.584,54,36,54z M36,42 c-3.033,0-5.5,2.468-5.5,5.5S32.967,53,36,53s5.5-2.468,5.5-5.5S39.033,42,36,42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,33H14c-0.276,0-0.5-0.224-0.5-0.5S13.724,32,14,32h24c0.276,0,0.5,0.224,0.5,0.5S38.276,33,38,33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38,38H14c-0.276,0-0.5-0.224-0.5-0.5S13.724,37,14,37h24c0.276,0,0.5,0.224,0.5,0.5S38.276,38,38,38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.242,51.742l0.002-0.001C41.329,50.655,42,49.156,42,47.5c0-3.314-2.686-6-6-6v6L40.242,51.742z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.243,52.241c-0.13,0-0.258-0.05-0.354-0.146l-4.242-4.242C35.553,47.76,35.5,47.633,35.5,47.5v-6 c0-0.276,0.224-0.5,0.5-0.5c3.584,0,6.5,2.916,6.5,6.5c0,1.735-0.675,3.367-1.902,4.595c-0.038,0.038-0.082,0.069-0.13,0.094 C40.396,52.225,40.319,52.241,40.243,52.241z M36.5,47.293l3.727,3.727c0.824-0.986,1.273-2.219,1.273-3.52 c0-2.864-2.201-5.225-5-5.478V47.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36,53.5c1.658,0,3.158-0.672,4.244-1.759l0,0L36,47.5h-6C30,50.814,32.686,53.5,36,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,54c-3.584,0-6.5-2.916-6.5-6.5c0-0.276,0.224-0.5,0.5-0.5h6c0.132,0,0.26,0.053,0.354,0.146l4.244,4.241 c0.094,0.094,0.146,0.221,0.146,0.354s-0.053,0.26-0.146,0.354C39.369,53.323,37.736,54,36,54z M30.522,48 c0.253,2.8,2.613,5,5.478,5c1.301,0,2.534-0.449,3.521-1.274L35.793,48H30.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,43h-8c-0.276,0-0.5-0.224-0.5-0.5S14.724,42,15,42h8c0.276,0,0.5,0.224,0.5,0.5S23.276,43,23,43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,48h-8c-0.276,0-0.5-0.224-0.5-0.5S14.724,47,15,47h8c0.276,0,0.5,0.224,0.5,0.5S23.276,48,23,48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,53h-8c-0.276,0-0.5-0.224-0.5-0.5S14.724,52,15,52h8c0.276,0,0.5,0.224,0.5,0.5S23.276,53,23,53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,59c-0.276,0-0.5-0.224-0.5-0.5v-2c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2 C57,58.776,56.776,59,56.5,59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,55c-0.276,0-0.5-0.224-0.5-0.5v-18c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v18 C57,54.776,56.776,55,56.5,55z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/신차품질.4b9382d7c2e454907ec0ee4577a13687.svg";
export { ForwardRef as ReactComponent };